import { FormattedCurrency } from '@iwIntlProvider/FormattedCurrency';
import { IconFileVisualizationOutline } from '@iwoca/icons';
import { FormattedMessage } from 'react-intl';

import { TopUpStatusAlertBox } from './TopUpStatusAlertBox';
import styles from '../TopUpStatusAlertBox.module.css';

export const TopUpPendingAlert = ({
    requestedAmount,
    requestedCashAmount
}: {
    requestedAmount: number;
    requestedCashAmount: number | undefined;
}) => {
    return (
        <TopUpStatusAlertBox
            variant="cancel"
            icon={
                <IconFileVisualizationOutline
                    className={styles.blueAlertBoxIcon}
                />
            }
            className={styles.blueAlertBox}
            description={
                <>
                    <strong>
                        <FormattedMessage
                            id="_.outstanding_view.topupPendingTitle"
                            defaultMessage="Additional funds requested"
                        />
                        {' - '}
                    </strong>

                    {requestedCashAmount ? (
                        <FormattedMessage
                            id="_.outstanding_view.topupPending"
                            defaultMessage="Thanks for your application for an additional {amount}. We'll aim to get back to you in 24 hours but please bear with us if we take a little longer."
                            values={{
                                amount: (
                                    <strong>
                                        <FormattedCurrency
                                            value={requestedCashAmount}
                                        />
                                    </strong>
                                )
                            }}
                        />
                    ) : (
                        <FormattedMessage
                            id="_.outstanding_view.topupPendingFallbackDescription"
                            defaultMessage="Thanks for your application for a top up to a credit limit of {amount}. We'll aim to get back to you in 24 hours but please bear with us if we take a little longer."
                            values={{
                                amount: (
                                    <strong>
                                        <FormattedCurrency
                                            value={requestedAmount}
                                        />
                                    </strong>
                                )
                            }}
                        />
                    )}
                </>
            }
        />
    );
};
